import { flatten, values } from 'lodash'

import axios from 'axios'
import jwt from '../helpers/jwt'
import router from '@/router'
import store from '@/store'
import * as Types from '@/store/types'

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

const handleResponseToken = response =>
{
	const token = response?.headers?.authorization

	const refreshed = response?.headers?.['x-token-refreshed']

	const isLogin = response?.config?.url?.includes('/auth/login')

	return new Promise
	(
		async resolve =>
		{
			if ( token && !isLogin )
			{
				await store.dispatch(Types.SET_TOKEN, { token, refreshed })
			}

			store.dispatch(Types.IS_NOT_LOADING)

			resolve(response)
		}
	)
}

const requestInterceptor = axios.interceptors.request.use
(
	config =>
	{
		const token = jwt.getToken()

		if ( token )
		{
			config.headers.common['Authorization'] = `Bearer ${token}`
		}

		store.dispatch(Types.IS_LOADING)

		return config
	},

	error => Promise.reject(error)
)

const responseInterceptor = axios.interceptors.response.use
(
	response => handleResponseToken(response),

	async error =>
	{
		const { response } = error ?? {}

		const { data, status } = response ?? {}

		if ( status == 200 )
		{
			await handleResponseToken(response)
		}

		switch ( status )
		{
			case 401:
				store.dispatch(Types.LOGOUT, { employeeLogout: false }).then(() => router.push({ name: 'auth.login', query: { to: router.currentRoute.fullPath } }))
				break
		}

		store.dispatch(Types.IS_NOT_LOADING)

		return Promise.reject(error)
	}
)